import GetBusinessUnitByUserIdRequestModelBase from '../_generated/modelBases/get-business-unit-by-user-id-request-model-base';

export default class GetBusinessUnitByUserIdRequestModel extends GetBusinessUnitByUserIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
